@if (clientList().length !== 0) {
  <div class="client-list">
    <div class="row mb-2 gx-2">
      <div class="col col-md-auto">
        <p-tag
          [icon]="activeClientFilter() === ClientFilterType.ActiveClients ? 'pi pi-filter-fill' : 'pi pi-filter'"
          [severity]="activeClientFilter() === ClientFilterType.ActiveClients ? 'contrast' : 'secondary'"
          value="in Behandlung"
          (click)="clientFilterClicked(ClientFilterType.ActiveClients)"
          class="w-100"
          styleClass="w-100" />
      </div>

      <div class="col col-md-auto">
        <p-tag
          [icon]="activeClientFilter() === ClientFilterType.InactiveClients ? 'pi pi-filter-fill' : 'pi pi-filter'"
          [severity]="activeClientFilter() === ClientFilterType.InactiveClients ? 'contrast' : 'secondary'"
          value="Abgeschlossen"
          (click)="clientFilterClicked(ClientFilterType.InactiveClients)"
          class="w-100"
          styleClass="w-100" />
      </div>
    </div>

    <div id="table-wrapper">
      <p-table
        id="table"
        [value]="filteredClientList()"
        [rowHover]="true"
        [style]="{'cursor': 'pointer', 'overflow': isMobile() ? 'scroll' : 'auto'}"
        [autoLayout]="true"
        [scrollable]="true"
        [showGridlines]="true"
        scrollHeight="flex"
      >

        <ng-template #header>
          <tr>
            <th>Name</th>
            <th>Geburtsdatum</th>
            <th>E-Mail</th>
            <th>Telefon</th>
            <th>Status</th>
          </tr>
        </ng-template>

        <ng-template
            #body
            let-client
            let-rowIndex="rowIndex">
          <tr
            (click)="routeToClientDetails(client.id)"
            [attr.data-cy]="'sana-tp-client-list-entry-' + rowIndex">

            <td>
              {{ client.fullNameWithTitle }} <br />
              @if (client.socialSecurityNumber) {
                <small class="text-muted">({{ client.socialSecurityNumber }})</small>
              }
            </td>

            <td>{{ client.dateOfBirth  | date:'dd.MM.yyyy' }}</td>

            <td>{{ client.email }}</td>

            <td><a [href]="'tel:' + client.phoneNumber">{{ client.phoneNumber }}</a></td>

            <td>
              @if (client.hasActiveTherapyPlan) {
                <p-badge
                  value="Behandlung"
                  severity="success"></p-badge>
              } @else {
                <p-badge
                  value="Abgeschlossen"
                  severity="contrast"></p-badge>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
